export default "__VITE_ASSET__RkAEPtdN__"